module.exports = __webpack_public_path__ + "static/media/iconInstagram.542ac916.svg";